import React from "react";
import Container from "../components/wrapper/container.wrapper";
import * as Translation from "../modules/translation";
import ErrorBoundary from "../components/wrapper/errorBoundary.wrapper";

export const TranslationRouter = ({ isAuthenticated }: {
    isAuthenticated: () => boolean,
}) => (
    {
        path: "/",
        element: <Container/>,
        children: [
            {
                path: "/translation",
                element: <Translation.List />,
                errorElement: <ErrorBoundary hasError={true} />,
            },
            {
                path: "/translation_import",
                element: <Translation.Import />,
                errorElement: <ErrorBoundary hasError={true} />,
            },
            {
                path: "/translation_entity_import",
                element: <Translation.EntityImport />,
                errorElement: <ErrorBoundary hasError={true} />,
            }
        ]
    }
)